// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("cocoon")
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')

import $ from 'jquery'
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker'

require("bootstrap")
require("bootstrap-datepicker")

require('website/bootstrap-select.min')
require('website/popper.min')
require('website/acommon')
require('website/step1_validation')
require('website/step3_validation')
require('website/user')
require('website/jquery-ui-1.10.1.custom.min')
require('website/jquery.jscroll')
require('website/jquery.timepicker.min')
require('website/office')
require('website/filter')
require('website/service')
require('website/maps')
require('website/document_group')
require('website/ad')
require('website/invoice')
import I18n from 'i18n-js'
window.I18n = I18n
require('i18n/translations')
// require('website/jquery.keyboard')
require('moment')
require("packs/select2setup")
require('website/mobiscroll.jquery.min.js')
require('website/recaptcha_signup')


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

require("trix")
require("@rails/actiontext")

$.fn.datepicker.dates.en = {
  days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
  daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
  daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],
  months:["January","February","March","April","May","June","July","August","September","October","November","December"],
  monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
  today:"Today",
  monthsTitle:"Months",
  clear:"Clear",
  weekStart:1,
  format:"dd.mm.yyyy",
  titleFormat: "dd.mm.yyyy"
}

$.fn.datepicker.dates.fi = {
  days:["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"],
  daysShort:["sun","maa","tii","kes","tor","per","lau"],
  daysMin:["su","ma","ti","ke","to","pe","la"],
  months:["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],
  monthsShort:["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],
  today:"tänään",
  clear:"Tyhjennä",
  weekStart:1,
  format:"dd.mm.yyyy",
  titleFormat: "dd.mm.yyyy"
}

document.addEventListener("DOMContentLoaded", function() {
  var locale = document.documentElement.lang || 'en';
  $('.datepicker').datepicker({
    format: 'dd.mm.yyyy',
    autoclose: true,
    todayBtn: 'linked',
    todayHighlight: true,
    orientation: 'bottom',
    weekStart: 1,
    language: locale,
    startDate: '0d'
  }).on('changeDate', function(e) {
    // Trigger validation when date picker changes
    var form = $(this).closest('form');
    var isDisplayDate = $(this).hasClass('display_date');

    // For display_date fields, trigger multiple validations with delays
    if (isDisplayDate) {
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 50);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 200);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 500);
    } else {
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 100);
    }
  });

  $("#auction_publication_date").on("change", function() {
    var form = $(this).closest('form');
    var auction_category = $("#auction_category").val();
    const publicationDateStr = $("#auction_publication_date").val();
    const auctionDateStr = $("#auction_auction_date").val();

    const auction_publication_date = parseDate(publicationDateStr);
    const auction_date = parseDate(auctionDateStr);

    // Universal date validation - check dates only if both exist
    if (auction_category == 'online_auction') {
      var isImmediate = $('#immediate_sale_ad').is(':checked');
      if (isImmediate) {
        // For immediate auctions, just clear any errors if publication_date is filled
        if (auction_publication_date) {
          $(".checkMandatory").removeClass("disableattchmentbutton");
          $("#auction_publication_date_notice").html("");
        }
      } else if (auction_publication_date && auction_date) {
        // For scheduled auctions, compare dates
        if(auction_publication_date < auction_date) {
          $("#auction_publication_date_notice").html("<div class='alert alert-warning alert-dismissible'>Publication end date must be bigger than Start date<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
          $(".checkMandatory").addClass("disableattchmentbutton");
        }else{
          $(".checkMandatory").removeClass("disableattchmentbutton");
          $("#auction_publication_date_notice").html("");
        }
      }
    } else if(auction_category == 'auction_notice' && auction_publication_date && auction_date) {
      if(auction_publication_date > auction_date) {
        $("#auction_notice_publication_date_notice").html("<div class='alert alert-warning alert-dismissible'>Publication date must be earlier than Auction date<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $(".checkMandatory").addClass("disableattchmentbutton");
      }else{
        $(".checkMandatory").removeClass("disableattchmentbutton");
        $("#auction_notice_publication_date_notice").html("");
      }
    }

    // Always re-validate form when date changes (universal)
    setTimeout(function() {
      validateAndToggleButtons(form);
      // Also trigger step3 validation if available
      if (typeof window.validateStep3 === 'function') {
        window.validateStep3();
      }
    }, 150);
    remove_validation_text(this);
  });

  $("#auction_auction_date").on("change", function() {
    var form = $(this).closest('form');
    var auction_category = $("#auction_category").val();
    const publicationDateStr = $("#auction_publication_date").val();
    const auctionDateStr = $("#auction_auction_date").val();

    const auction_publication_date = parseDate(publicationDateStr);
    const auction_date = parseDate(auctionDateStr);
    if(auction_publication_date && auction_date){
      if (auction_category == 'online_auction'){
        if(auction_publication_date < auction_date) {
          $("#scheduled_date_notice").html("<div class='alert alert-warning alert-dismissible'>Publication start date must be earlier than Publication end date.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
          $(".checkMandatory").addClass("disableattchmentbutton");
        }else{
          $(".checkMandatory").removeClass("disableattchmentbutton");
          $("#scheduled_date_notice").html("");
        }
      } else if(auction_category == 'auction_notice') {
        if(auction_publication_date > auction_date) {
          $("#auction_notice_auction_date_notice").html("<div class='alert alert-warning alert-dismissible'>Auction date must be bigger than Publication date<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
          $(".checkMandatory").addClass("disableattchmentbutton");
        }else{
          $(".checkMandatory").removeClass("disableattchmentbutton");
          $("#auction_notice_auction_date_notice").html("");
        }
      }
      $(form).find("button[type='submit']").prop('disabled',false);
    }
    // Always re-validate form when date changes
    setTimeout(function() {
      validateAndToggleButtons(form);
      // Also trigger step3 validation if available
      if (typeof window.validateStep3 === 'function') {
        window.validateStep3();
      }
    }, 100);
    remove_validation_text(this);
  });

  $(".ad_attachment_date").on("change", function() {
    var auction_id = $("#auction_id").val();
    var id = getId(this.id);
    var attachment_date = $("#ad_attachment_date_"+id).val();

    $.ajax({
      url: '/admin/auctions/'+ auction_id +'/update_attachments',
      type: 'GET',
      data: {id: auction_id, attachment_id: id, attachment_date: attachment_date}
    });
  });


});

// Scroll-to-top button (ARROW UP) - same behavior as front page, for Manage OWN/ANOTHER and archive
document.addEventListener('DOMContentLoaded', function() {
  var SCROLL_THRESHOLD = 200;
  function checkScrollToTopVisibility() {
    var btn = document.getElementById('scroll-to-top');
    if (!btn) return;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > SCROLL_THRESHOLD) {
      btn.classList.add('scroll-to-top--visible');
    } else {
      btn.classList.remove('scroll-to-top--visible');
    }
  }
  function scrollToTop(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  window.addEventListener('scroll', checkScrollToTopVisibility);
  checkScrollToTopVisibility();
  var scrollToTopBtn = document.getElementById('scroll-to-top');
  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener('click', scrollToTop);
  }
});

$(document).on('ajax:complete', function() {
  var locale = document.documentElement.lang || 'en';
  $('.datepicker').datepicker({
    format: 'dd.mm.yyyy',
    autoclose: true,
    todayBtn: 'linked',
    todayHighlight: true,
    orientation: 'bottom',
    weekStart: 1,
    language: locale,
    startDate: '0d'
  }).on('changeDate', function(e) {
    var form = $(this).closest('form');
    var isDisplayDate = $(this).hasClass('display_date');

    // For display_date fields, trigger multiple validations with delays
    if (isDisplayDate) {
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 50);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 200);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 500);
    } else {
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 100);
    }
  });
});

function parseDate(str) {
  // str is in DD.MM.YYYY
  const [day, month, year] = str.split(".");
  return new Date(`${year}-${month}-${day}T00:00:00`);
}

function remove_validation_text(element){
  $(element).parent().closest('div').removeClass('has-error');
  $(element).parent().closest('div').find('small:eq(0)').remove();
  $(element).parent().closest('div').find('i:eq(0)').remove();
}

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}
  
$(document).ready(function(){

  $(document).on('click', '#save_send_feedback_modal_form_btn', function(){
    var browser_data;
    var browser_parser = new UAParser();
    var browser_global_data = browser_parser.getResult();
    var screen_size;

    if(window){
      if(window.screen){
        screen_size = window.screen.width + 'x' + window.screen.height
      }
    }

    browser_data = {
                    'browser_name': browser_global_data.browser.name,
                    'browser_version': browser_global_data.browser.version,
                    'os_name': browser_global_data.os.name,
                    'os_version': browser_global_data.os.version,
                    'screen_size': screen_size,
                    'device_type': browser_global_data.device.type
                  }

    var data = JSON.stringify(browser_data);
    var redirection_url = window.location.href;
    $.ajax({
      url: '/send_feedback_developers_form',
      type: 'POST',
      data: {browser_data : data, current_page_url : redirection_url}
    });
  });
});